import { useState, useEffect, useCallback } from 'react';
import { safeGet, safeSet } from '../../utils/safeStorage';
import { STORAGE_KEYS } from './storageKeys';

export function useNotificationsState() {
  const [notifications, setNotifications] = useState(() => safeGet(STORAGE_KEYS.notifications, []));

  useEffect(() => { safeSet(STORAGE_KEYS.notifications, notifications); }, [notifications]);

  const addNotification = useCallback((n) => {
    setNotifications((arr) => [
      {
        id: `N-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        createdAt: new Date().toISOString(),
        readBy: [],
        ...n,
      },
      ...arr,
    ]);
  }, []);

  const markNotificationRead = useCallback((id, userId) => {
    setNotifications((arr) => arr.map((n) =>
      n.id === id && !n.readBy.includes(userId) ? { ...n, readBy: [...n.readBy, userId] } : n
    ));
  }, []);

  const markAllNotificationsRead = useCallback((userId) => {
    setNotifications((arr) => arr.map((n) =>
      n.readBy.includes(userId) ? n : { ...n, readBy: [...n.readBy, userId] }
    ));
  }, []);

  return { notifications, addNotification, markNotificationRead, markAllNotificationsRead };
}
